import React from "react";

import VocabBuilder from "./Components/VocabBuilder/VocabBuilder";

function App() {
	return (
		<div className="app">
			<VocabBuilder />
		</div>
	);
}

export default App;
